/**
 * The contact field a patient's medical record number lives in.
 *
 * Provisioned when ClinicSoft is connected, so it is a dynamic field like any
 * other - this key is how the one field that can be pulled from the CRM is told
 * apart from the ones a workspace added by hand.
 */
export const PATIENT_MRN_FIELD_KEY = "mrn";
